import Vue from 'vue'
import App from './App.vue'
import '@/assets/style/index.css'
import router from './router'
import store from './store'
import axios from 'axios'
import dayjs from 'dayjs'

Vue.config.productionTip = false
Vue.prototype.dayjs = dayjs

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
